<template>

<div>
  <div>
      <h4>Site Project</h4>
      <el-button v-if="isManager('project|finance')" type="text" @click="editState()"><i :class="editing ? 'fa fa-check-circle' : 'fa fa-edit'"></i></el-button>
      <el-button v-if="this.editing" type="text" @click="editing = false"><i class="fa fa-times-circle"></i></el-button>
  </div>



  <el-form inline label-position="left" ref="projectForm" :model="details">

    <number-input v-if="isSuper()" label="Sharer #" v-model="details.sharerNo" :disabled="!editing" />
    <number-input label="Sharer #" v-else v-model="details.sharerNo" disabled />

    <date-input label="Handover" v-model="details.handover" :disabled="!editing" />
    <date-input label="Commencement" v-model="details.startBilling" :disabled="!editing" />
    <date-input label="On Air" v-model="details.onAir" :disabled="!editing" />

    <text-input label="Telco ID." v-model="details.telcoSiteId" :disabled="!editing" />
    <text-input label="Phase" v-model="details.phase" :disabled="!editing" />

    <select-service-type v-model="details.serviceType" :disabled="!editing" />
    <select-spectrum v-model="details.spectrumBand" :disabled="!editing" />

    <el-alert  v-if="editing" type="info" description="Exclude Sharer Count means exclude from fee calculations and sharer counts in general" show-icon :closable="false" effect="dark" />
    <switch-input
      label="Include Share Count"
      v-model="details.excludeShareCount"
        on-text="Exlcude from Sharer Counts" on-color="#F56C6C" on-icon="fa fa-times-circle"
        off-text="Include in Sharer Counts"  off-color="#67C23A" off-icon="fa fa-check-circle"
        :disabled="!editing" />


</el-form>

<buildings-table :site-id="details.site_id" :site-data="siteData" :owner-id="details.organisation_id" />

</div>

</template>

<script>

import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'

import SelectSpectrum from '@/components/atoms/selects/SelectSpectrum'
import SelectServiceType from '@/components/atoms/selects/SelectServiceType'

import BuildingsTable from '@/components/assets/subcat/BuildingsEquipTable'

export default {
  mixins: [PostMixins, DateMixins],

  components: {
    BuildingsTable,
    SelectSpectrum,
    SelectServiceType
  },

  props: {
    sharer: {
      type: Object,
      required: true
    },

    siteData: {
      type: Object
    },

    editMode: {
      type: Boolean,
      default: false
    }

  },

  methods: {
    editState () {
      if (this.editing) {

        if (this.details.handover) {
          this.details.handover = this.formatDateSql(this.details.handover)
        }

        if (this.details.startBilling) {
          this.details.startBilling = this.formatDateSql(this.details.startBilling)
        }

        if (this.details.onAir) {
          this.details.onAir = this.formatDateSql(this.details.onAir)
        }

        this.saveForm(this, '/licensees', this.details.id, this.details, 'Sharer Utility Data', this.saveSucccess)
        this.editing = false
      } else {
        this.editing = true
      }
    }
  },

  data () {
    return {
      editing: this.editMode,
      details: this.sharer
    }
  },

  mounted () {
//    console.log('siteData', this.siteData)
  }
}

</script>
